import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-image-portrait',
  templateUrl: './image-portrait.component.html',
  styleUrls: ['./image-portrait.component.css']
})
export class ImagePortraitComponent implements OnInit {

  @Input() city!: string;
  @Input() image!: string;
  @Input() description: string = '';
  @Input() link: string = '#';
  @Input() date: string = '';
  @Input() id: string;

  selectedImage: string = '';
  viewerOpen: boolean = false;
  
  constructor() { }

  ngOnInit(): void {
  }

  openImage(imageUrl: string) {
    this.selectedImage = imageUrl;
    this.viewerOpen = true;
  }

}